import gql from "graphql-tag";

export const GET_USER = gql`
  query getUser {
    user {
      uid
      fullName
      email
      checkbox
      psychometric
      maturity
      adapter
      phone
      password
      filters
      registrationFormChoices
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser(
    $psychometric: String!
    $maturity: String!
    $adapter: String!
    $filters: JSON!
    $registrationFormChoices: JSON!
  ) {
    updateUser(
      psychometric: $psychometric
      maturity: $maturity
      adapter: $adapter
      filters: $filters
      registrationFormChoices: $registrationFormChoices
    ) {
      uid
      fullName
      email
      psychometric
      maturity
      adapter
      phone
      checkbox
      password
      filters
      registrationFormChoices
    }
  }
`;

export const GET_LAST_SCORE = gql `
  query getLastScore ($scoresData: JSON!) {
    getLastScore (scoresData: $scoresData) {
      body
    }
  }
`;
